import { api_GET, api_POST, api_PUT, api_DELETE, api_GET_Unauthorize, api_POST_Unauthorize } from "./_api.js";

const setor_api = {
    GetList: (prefeitura_id = "") => {
        const promise = new Promise((resolve, reject) => {
            api_GET_Unauthorize(`Setor/GetList/${prefeitura_id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetListFiltro: (prefeitura_id = "") => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Setor/GetListFiltro/${prefeitura_id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Setor/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Setor", obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("Setor", obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetRegionalByLocalidade: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST_Unauthorize("Setor/GetRegionalByLocalidade", obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}
export default setor_api;